import React from 'react';
import Build1_54 from '../assets/images/Builds/Huta M8 Peritus #6/Vitae Guitars  - -54.jpg';

const ContactSection = ({ formData, formErrors, handleInputChange, handleSubmit, isSubmitting, submitStatus }) => {
  return (
    <section id="contact" className="py-32 bg-theme-bg-primary relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5"></div>
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-6xl mx-auto bg-theme-bg-card/50 backdrop-blur-xl rounded-2xl shadow-2xl overflow-hidden border border-white/5 ">
          <div className="flex flex-col md:flex-row">
            <div className="md:w-2/5 relative min-h-[400px] ">
              <img
                src={Build1_54}
                alt="Vitæ Guitars Guitar Detail"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-black/80 flex flex-col justify-center p-10 text-white ">
                <h3 className="text-3xl font-bold mb-8">Get in Touch</h3>
                <div className="space-y-8">
                  <div className="flex items-start gap-4 group">
                    <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center group-hover:bg-theme-primary-500 transition-colors">
                      <i className="fas fa-envelope text-white"></i>
                    </div>
                    <div>
                      <span className="block text-sm text-gray-400 uppercase tracking-wider mb-1">Email</span>
                      <span className="text-lg font-medium">VitaeGuitars@gmail.com</span>
                    </div>
                  </div>
                  <div className="flex items-start gap-4 group">
                    <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center group-hover:bg-theme-primary-500 transition-colors">
                      <i className="fas fa-phone text-white"></i>
                    </div>
                    <div>
                      <span className="block text-sm text-gray-400 uppercase tracking-wider mb-1">Phone</span>
                      <span className="text-lg font-medium">+972 523484419</span>
                    </div>
                  </div>
                  <div className="flex items-start gap-4 group">
                    <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center group-hover:bg-theme-primary-500 transition-colors">
                      <i className="fas fa-map-marker-alt text-white"></i>
                    </div>
                    <div>
                      <span className="block text-sm text-gray-400 uppercase tracking-wider mb-1">Location</span>
                      <span className="text-lg font-medium">Ziman Yosef 16, Tel-Aviv, Israel</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="md:w-3/5 p-10 md:p-16">
              <h2 className="text-4xl font-bold mb-4 text-white">Let's Build Something Special</h2>
              <p className="text-gray-400 mb-10 text-lg">
                Ready to start your custom build? Have questions about our process? We'd love to hear from you.
              </p>

              {/* Success Message */}
              {submitStatus === 'success' && (
                <div className="mb-8 p-6 bg-green-500/10 border border-green-500/50 rounded-lg backdrop-blur-sm">
                  <p className="text-green-400 flex items-center text-lg">
                    <i className="fas fa-check-circle mr-3 text-xl"></i>
                    Message sent successfully! We'll be in touch soon.
                  </p>
                </div>
              )}

              {/* Error Message */}
              {submitStatus === 'error' && (
                <div className="mb-8 p-6 bg-red-500/10 border border-red-500/50 rounded-lg backdrop-blur-sm">
                  <p className="text-red-400 flex items-center text-lg">
                    <i className="fas fa-exclamation-circle mr-3 text-xl"></i>
                    Something went wrong. Please try again.
                  </p>
                </div>
              )}

              <form onSubmit={handleSubmit} className="space-y-8">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div className="relative group">
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      disabled={isSubmitting}
                      className={`peer w-full bg-transparent border-b-2 ${formErrors.name ? 'border-red-500' : 'border-gray-700'} py-3 text-white focus:outline-none focus:border-theme-primary-500 transition-colors placeholder-transparent`}
                      placeholder="Name"
                    />
                    <label htmlFor="name" className={`absolute left-0 -top-3.5 text-sm ${formErrors.name ? 'text-red-500' : 'text-gray-500'} transition-all peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-500 peer-placeholder-shown:top-3 peer-focus:-top-3.5 peer-focus:text-theme-primary-500 peer-focus:text-sm`}>
                      Name
                    </label>
                    {formErrors.name && <p className="text-red-500 text-xs mt-1 absolute">{formErrors.name}</p>}
                  </div>
                  
                  <div className="relative group">
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      disabled={isSubmitting}
                      className={`peer w-full bg-transparent border-b-2 ${formErrors.phone ? 'border-red-500' : 'border-gray-700'} py-3 text-white focus:outline-none focus:border-theme-primary-500 transition-colors placeholder-transparent`}
                      placeholder="Phone"
                    />
                    <label htmlFor="phone" className={`absolute left-0 -top-3.5 text-sm ${formErrors.phone ? 'text-red-500' : 'text-gray-500'} transition-all peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-500 peer-placeholder-shown:top-3 peer-focus:-top-3.5 peer-focus:text-theme-primary-500 peer-focus:text-sm`}>
                      Phone
                    </label>
                    {formErrors.phone && <p className="text-red-500 text-xs mt-1 absolute">{formErrors.phone}</p>}
                  </div>
                </div>

                <div className="relative group">
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    disabled={isSubmitting}
                    className={`peer w-full bg-transparent border-b-2 ${formErrors.email ? 'border-red-500' : 'border-gray-700'} py-3 text-white focus:outline-none focus:border-theme-primary-500 transition-colors placeholder-transparent`}
                    placeholder="Email"
                  />
                  <label htmlFor="email" className={`absolute left-0 -top-3.5 text-sm ${formErrors.email ? 'text-red-500' : 'text-gray-500'} transition-all peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-500 peer-placeholder-shown:top-3 peer-focus:-top-3.5 peer-focus:text-theme-primary-500 peer-focus:text-sm`}>
                    Email
                  </label>
                  {formErrors.email && <p className="text-red-500 text-xs mt-1 absolute">{formErrors.email}</p>}
                </div>

                <div className="relative group">
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    disabled={isSubmitting}
                    rows={4}
                    className={`peer w-full bg-transparent border-b-2 ${formErrors.message ? 'border-red-500' : 'border-gray-700'} py-3 text-white focus:outline-none focus:border-theme-primary-500 transition-colors placeholder-transparent resize-none`}
                    placeholder="Message"
                  ></textarea>
                  <label htmlFor="message" className={`absolute left-0 -top-3.5 text-sm ${formErrors.message ? 'text-red-500' : 'text-gray-500'} transition-all peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-500 peer-placeholder-shown:top-3 peer-focus:-top-3.5 peer-focus:text-theme-primary-500 peer-focus:text-sm`}>
                    Tell us about your dream guitar
                  </label>
                  {formErrors.message && <p className="text-red-500 text-xs mt-1 absolute">{formErrors.message}</p>}
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="group relative w-full bg-theme-primary-500 text-white px-8 py-4 rounded-lg font-bold tracking-widest uppercase overflow-hidden hover:bg-theme-primary-600 transition-all shadow-lg hover:shadow-theme-primary-500/30 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <span className="relative z-10 flex items-center justify-center gap-3">
                    {isSubmitting ? (
                      <>
                        <i className="fas fa-spinner fa-spin"></i>
                        Sending...
                      </>
                    ) : (
                      <>
                        Send Message
                        <i className="fas fa-paper-plane group-hover:translate-x-1 transition-transform"></i>
                      </>
                    )}
                  </span>
                  <div className="absolute inset-0 h-full w-full scale-0 rounded-lg transition-all duration-300 group-hover:scale-100 group-hover:bg-theme-primary-600/50"></div>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
